<template>
  <div class="pages">
    <navTop></navTop>
    <div class="box">
      <li>
        <span>1、船头船尾</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jycttw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.jycttw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>2、吃水</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jycstw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.jycstw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>3、左右倾斜</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jyqxtw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.jyqxtw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>舱 1 (视频)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jyc1sw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" :key="index" v-for="(item, index) in dataList.jyc1sw.split('|').map(str => JSON.parse(str))">
            <video :src="item.image" @click="togglePlayback(item.image)"
                   width="100px" height="50px"
                   style="border-radius: 10px;border: 1px solid rgba(0, 255, 255, 0.25); width: 392px;height: 292px;margin-right: 50px;margin-bottom: 20px;" />
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>
      <li>
        <span>舱 1 (图片)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jyc1tw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.jyc1tw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>舱 2 (视频)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jyc2sw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" :key="index" v-for="(item, index) in dataList.jyc2sw.split('|').map(str => JSON.parse(str))">
            <video :src="item.image" @click="togglePlayback(item.image)"
                   width="100px" height="50px"
                   style="border-radius: 10px;border: 1px solid rgba(0, 255, 255, 0.25); width: 392px;height: 292px;margin-right: 50px;margin-bottom: 20px;" />
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>
      <li>
        <span>舱 2 (图片)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jyc2tw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.jyc2tw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>舱 3 (视频)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jyc3sw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" :key="index" v-for="(item, index) in dataList.jyc3sw.split('|').map(str => JSON.parse(str))">
            <video :src="item.image" @click="togglePlayback(item.image)"
                   width="100px" height="50px"
                   style="border-radius: 10px;border: 1px solid rgba(0, 255, 255, 0.25); width: 392px;height: 292px;margin-right: 50px;margin-bottom: 20px;" />
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>
      <li>
        <span>舱 3 (图片)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jyc3tw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.jyc3tw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>舱 4 (视频)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jyc4sw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" :key="index" v-for="(item, index) in dataList.jyc4sw.split('|').map(str => JSON.parse(str))">
            <video :src="item.image" @click="togglePlayback(item.image)"
                   width="100px" height="50px"
                   style="border-radius: 10px;border: 1px solid rgba(0, 255, 255, 0.25); width: 392px;height: 292px;margin-right: 50px;margin-bottom: 20px;" />
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>
      <li>
        <span>舱 4 (图片)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jyc4tw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.jyc4tw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>舱 5 (视频)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jyc5sw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" :key="index" v-for="(item, index) in dataList.jyc5sw.split('|').map(str => JSON.parse(str))">
            <video :src="item.image" @click="togglePlayback(item.image)"
                   width="100px" height="50px"
                   style="border-radius: 10px;border: 1px solid rgba(0, 255, 255, 0.25); width: 392px;height: 292px;margin-right: 50px;margin-bottom: 20px;" />
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>
      <li>
        <span>舱 5 (图片)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jyc5tw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.jyc5tw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>舱 6 (视频)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jyc6sw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" :key="index" v-for="(item, index) in dataList.jyc6sw.split('|').map(str => JSON.parse(str))">
            <video :src="item.image" @click="togglePlayback(item.image)"
                   width="100px" height="50px"
                   style="border-radius: 10px;border: 1px solid rgba(0, 255, 255, 0.25); width: 392px;height: 292px;margin-right: 50px;margin-bottom: 20px;" />
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>
      <li>
        <span>舱 6 (图片)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jyc6tw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.jyc6tw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>舱 7 (视频)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jyc7sw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" :key="index" v-for="(item, index) in dataList.jyc7sw.split('|').map(str => JSON.parse(str))">
            <video :src="item.image" @click="togglePlayback(item.image)"
                   width="100px" height="50px"
                   style="border-radius: 10px;border: 1px solid rgba(0, 255, 255, 0.25); width: 392px;height: 292px;margin-right: 50px;margin-bottom: 20px;" />
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>
      <li>
        <span>舱 7 (图片)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.jyc7tw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.jyc7tw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>8. (H.S.F.O）</span>
        <span>{{dataList.jyhs01}}</span>
        <span style="color: #FFFFFF">{{dataList.jyhs02}}</span>
      </li>

      <li>
        <span>9.（L.S.F.O）</span>
        <span>{{dataList.jyls01}}</span>
        <span style="color: #FFFFFF">{{dataList.jyls02}}</span>
      </li>

      <li>
        <span>10.（M.D.O）</span>
        <span>{{dataList.jymd01}}</span>
        <span style="color: #FFFFFF">{{dataList.jymd01}}</span>
      </li>

      <li>
        <span>11.（M.G.O）</span>
        <span>{{dataList.jymg01}}</span>
        <span style="color: #FFFFFF">{{dataList.jymg01}}</span>
      </li>
    </div>

    <el-dialog
        title="视频"
        size="small"
        v-dialogDrag
        :visible.sync="isVisible"
        :before-close="handleClose">
      <div class="video-player">
        <!-- 视频元素 -->
        <video
            ref="videoPlayer"
            :src="videoSrc"
            style="width: 100%;height: auto;display: block;"
            @timeupdate="updateProgress"
            @play="onPlay"
            @pause="onPause"
            @loadedmetadata="onLoadedMetadata"/>

        <!-- 控制栏 -->
        <div class="controls">
          <!-- 播放/暂停按钮 -->
          <button @click="togglePlayPause" class="control-btn">
            <img v-if="!isPlaying" src="../../assets/stop_icon.png" style="width: 30px;height: 30px;"/>
            <img v-if="isPlaying" src="../../assets/start_icon.png" style="width: 30px;height: 30px;"/>
          </button>

          <!-- 进度条 -->
          <div class="progress-bar" @click="seekToTime">
            <div class="progress" :style="{ width: progress + '%' }"></div>
          </div>

          <!-- 时间显示 -->
          <span class="time">{{ currentTime }} / {{ duration }}</span>

          <!-- 全屏按钮 -->
          <button @click="toggleFullScreen" class="control-btn">
            <i class="fas fa-expand"></i>
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import pdf from 'vue-pdf';
export default {
	name: 'newJy',
	components: {
		navTop,
		pdf
	},
	data() {
		return {
			dataList: {},
			num: '',
      videoSrc: '', // 视频URL
      isPlaying: false, // 是否正在播放
      progress: 0, // 播放进度
      currentTime: '00:00', // 当前播放时间
      duration: '00:00', // 视频总时长
      videoList:[],
      isVisible:false
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.getSchedulejy();
		}
	},
	methods: {
		getSchedulejy() {
			let data = {
				id: this.id
			};
			this.$api.schedulejy(data).then(res => {
				console.log('schedulejy=',res);
				if (res.result == 0) {
					this.dataList = res.data;
					if (res.data.jy041) {
						if (this.getSuffix(res.data.jy041) == 'pdf') {
							this.num = 1;
						} else {
							this.num = 0;
						}
					}
				}
			});
		},
		// 截取后缀名
		getSuffix(str) {
			var index = str.lastIndexOf('.');
			return str.substr(index + 1);
		},
    togglePlayback(item){
      this.videoSrc=item
      this.isVisible=true
    },

    // 切换播放/暂停
    togglePlayPause() {
      const video = this.$refs.videoPlayer;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },

    // 更新播放进度
    updateProgress() {
      const video = this.$refs.videoPlayer;
      this.progress = (video.currentTime / video.duration) * 100; // 计算进度百分比
      this.currentTime = this.formatTime(video.currentTime); // 格式化当前时间
    },

    // 跳转到指定时间
    seekToTime(event) {
      const video = this.$refs.videoPlayer;
      const progressBar = event.currentTarget;
      const clickPosition = event.offsetX; // 获取点击位置
      const progressBarWidth = progressBar.clientWidth; // 获取进度条宽度
      const seekTime = (clickPosition / progressBarWidth) * video.duration; // 计算跳转时间
      video.currentTime = seekTime;
    },

    // 播放事件
    onPlay() {
      this.isPlaying = true;
    },

    // 暂停事件
    onPause() {
      this.isPlaying = false;
    },

    // 视频元数据加载完成
    onLoadedMetadata() {
      const video = this.$refs.videoPlayer;
      this.duration = this.formatTime(video.duration); // 初始化总时长
    },

    // 切换全屏
    toggleFullScreen() {
      const video = this.$refs.videoPlayer;
      if (!document.fullscreenElement) {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.mozRequestFullScreen) {
          video.mozRequestFullScreen();
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) {
          video.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    },

    // 格式化时间（秒 -> MM:SS）
    formatTime(time) {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    },
    handleClose(){
      this.$refs.videoPlayer.pause();
      this.isVisible = false;
    }
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	span{color: #fff;}
	.li12 li{color: #fff !important;}
	.box {
		margin: 50px auto;
		border: 1px solid rgba(0, 255, 255, 0.25);
		border-radius: 10px;
		padding: 45px 45px 38px 56px;
		box-sizing: border-box;
		box-shadow: 0 0 300px 100px #043138 inset;
		li {
			display: flex;
			flex-direction: column;
			padding-bottom: 20px;
			box-sizing: border-box;
			span:nth-child(1) {
				color: #00fff0;
				font-size: 24px;
				line-height: 1em;
			}
			span:nth-child(2) {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			a {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			.img {
				margin-top: 15px;
				display: block;
				width: 392px;
				height: 292px;
				border-radius: 10px;
			}
			.imgs {
				margin-top: 15px;
				display: flex;
				flex-wrap: wrap;
				img {
					display: block;
					width: 392px;
					height: 292px;
					border-radius: 10px;
					margin-right: 58px;
					margin-bottom: 40px;
				}
				img:nth-child(3n) {
					margin-right: 0;
				}
			}
		}
	}
}
</style>
